import { useEffect, useState } from 'react';

export const useWindowResizeListener = () => {
  const [size, setSize] = useState({ width: 0, height: 0 });
  const onResize = () => {
    setSize({
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    });
  };

  useEffect(() => {
    if (typeof document === 'undefined') return;
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    onResize();
  }, []);
  return size;
};
